import { render, staticRenderFns } from "./GodmodeInfoBanner.vue?vue&type=template&id=674ee9d7&scoped=true&"
import script from "./GodmodeInfoBanner.vue?vue&type=script&lang=js&"
export * from "./GodmodeInfoBanner.vue?vue&type=script&lang=js&"
import style0 from "./GodmodeInfoBanner.vue?vue&type=style&index=0&id=674ee9d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674ee9d7",
  null
  
)

export default component.exports